import EVImg from '@components/EVImg';
import { AspectBox } from '@components/Layout';
import { FC } from 'react';
import { GridContainer } from './styles';

export interface ImageStackProps {
  imgs: any[];
}

const ImageStack: FC<ImageStackProps> = ({ imgs }) => {
  const imageAspectRatios = {
    1: [
      // image length of 1, etc
      [2 / 1, 3 / 1, 3 / 1],
    ],
    2: [
      [2 / 1, 3 / 1, 3 / 1],
      [2 / 1, 3 / 1, 3 / 1],
    ],
    3: [
      [2 / 1, 3 / 1, 3 / 1],
      [1, 3 / 2, 3 / 2],
      [1, 3 / 2, 3 / 2],
    ],
  };

  return (
    <GridContainer $amount={imgs.length}>
      {imgs &&
        imgs.map((img, ind) => (
          <AspectBox $ratio={imageAspectRatios[imgs.length][ind]} key={ind}>
            {typeof img === 'object' ? ( // should be an object (image with focal point), but this will accept the image url as well
              <EVImg imageFocalPointData={img} sizes={['100vw', '100vw', '500px']} />
            ) : (
              <EVImg src={img} sizes={['100vw', '100vw', '500px']} />
            )}
          </AspectBox>
        ))}
    </GridContainer>
  );
};

export default ImageStack;
